(ns ncr.sidebar.common
  (:require
   [clojure.core.match :refer [match]]
   [ncr.etc.util :as u]
   [ncr.widgets.core :as w]
   [ncr.etc.pf :as pf]))

(defn c-section [{:keys [icon label inner-props]} & children]
  (into
    [pf/c-nav-expandable
     (w/merge-props
       inner-props
       {:title
        [:span
         [w/c-mdi-icon {:icon icon}]
         [:span.pf-u-pl-sm label]]})]
    children))

(defn c-sidebar-item [{:keys [href icon class on-click on-ctrl-click inner-props entry]} & children]
  [pf/c-nav-item
   {:class class
    :prevent-default true
    :on-click
    (fn [e]
      (u/on-click-modifiers e
        {:on-ctrl-click #(on-ctrl-click % entry)
         :on-click #(on-click % entry)}))}
   [:a (w/merge-props inner-props {:href href})
    [pf/c-split {:class :pf-u-flex-grow-1}
     (when (some? icon)
       [pf/c-split-item
        [w/c-mdi-icon {:class :pf-u-pr-sm :icon icon}]])
     (into [pf/c-split-item {:is-filled true}] children)]]])